import { render, staticRenderFns } from "./OneClickJumpPage.vue?vue&type=template&id=54dbd50e&scoped=true&"
import script from "./OneClickJumpPage.vue?vue&type=script&lang=tsx&"
export * from "./OneClickJumpPage.vue?vue&type=script&lang=tsx&"
import style0 from "./OneClickJumpPage.vue?vue&type=style&index=0&id=54dbd50e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dbd50e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/adlandingpage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54dbd50e')) {
      api.createRecord('54dbd50e', component.options)
    } else {
      api.reload('54dbd50e', component.options)
    }
    module.hot.accept("./OneClickJumpPage.vue?vue&type=template&id=54dbd50e&scoped=true&", function () {
      api.rerender('54dbd50e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OneClickJumpPage.vue"
export default component.exports